export default __webpack_public_path__ + "static/media/logo-medway-minificado.ff674172.png";